var map = {
	"./ai.png": "ff77",
	"./daxiao.png": "54c9",
	"./haixiu.png": "1999",
	"./huaixiao.png": "cacf",
	"./jingya.png": "8a76",
	"./le.png": "c628",
	"./nu.png": "1c4e",
	"./wunai.png": "9194"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08e5";